<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <circle cx="12" cy="12" r="11.5" stroke="#000"/>
  <path stroke="#000" d="M6.667 12h10.666M12 6.667v10.666"/>
</svg>
